import { api } from '@/services'

export const adminHostPendingInvoices = (params) => {
  return api.get('admin/invoice/hostPending', { params })
}

export const adminSearchInvoices = (params) => {
  return api.get('admin/invoice/search', { params })
}

export const adminRefuseInvoice = (invoiceId) => {
  return api.delete(`admin/invoice/${invoiceId}`)
}

export const adminPayInvoices = (payload) => {
  return api.post('admin/invoice/transfer', payload)
}

export const adminApproveInvoices = (data) => {
  return api.post('admin/invoice/approve', data)
}

export const adminRemoveInvoice = (invoiceId) => {
  return api.delete(`admin/invoice/${invoiceId}`)
}

export const attachAdminInvoice = (invoiceData) => {
  return api.post(`/admin/invoice/${invoiceData.id}/attachFile`, invoiceData)
}

export const createAdminInvoice = (invoiceData) => {
  return api.post('admin/invoice/create', invoiceData)
}
  export const adminInvoicesZip = (filterParams) => {
    return api.get('/admin/invoice/invoicesZip', {
      params: filterParams,
      responseType: 'blob'
    })
}
